(function () {
  const section = document.currentScript.closest('section');

  function setLineLengths() {
    const labelElements = Array.from(section.querySelectorAll('[data-label]'));

    labelElements.forEach(function (labelElement, index) {
      const nextLabelElement = labelElements[index + 1];
      if (!nextLabelElement) return;

      const currentRect = labelElement.getBoundingClientRect();
      const nextRect = nextLabelElement.getBoundingClientRect();
      const distance = nextRect.left - currentRect.right;

      labelElement.style.setProperty('--line-width', distance + 'px');
    });
  }

  setLineLengths();

  window.addEventListener('resize', setLineLengths);
})();
